import { createContext } from 'react';
import { AppAbility } from './ability';
import { PureAbility } from '@casl/ability';

export const AbilityContext = createContext<AppAbility>(new PureAbility());